import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { NewRolePage } from '../../../features/admin/role-pages'

export const Route = createFileRoute('/_app/roles/new')({
  staticData: { crumb: 'roleNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'roles.manage'),
  component: NewRolePage,
})
